import { useEffect } from "react";
import Typed from "typed.js";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./Hero.css";
import SEO from "../SEO";
export default function Hero() {
  useEffect(() => {
    AOS.init({ once: true, duration: 800 });

    const typed = new Typed("#typed", {
      strings: [
        "Full-Stack Web Development",
        "Cloud & Microservices Architecture",
        "AI-Powered Solutions",
        "Enterprise Software Systems",
        "Mobile App Development",
      ],
      typeSpeed: 50,
      backSpeed: 30,
      loop: true,
    });

    return () => typed.destroy();
  }, []);

  return (
    <>
      <SEO
        title="MZR Software – Custom Software & Web Solutions"
        description="Enterprise-grade software solutions including ERP, POS, mobile apps, AI automation, and cloud DevOps services."
        image="https://mzrsoftware.com/assets/images/og-homepage.jpg"
        url="https://mzrsoftware.com/"
      />
      <header className="hero-portfolio text-center text-light position-relative">
        <div className="hero-gradient"></div>
        <div className="hero-animation">
          <div className="blob blob-1"></div>
          <div className="blob blob-2"></div>
          <div className="blob blob-3"></div>
        </div>

        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="hero-content py-5">
            <div className="mb-4" data-aos="fade-down" data-aos-delay="50">
              <span className="badge badge-premium px-4 py-2">
                ⭐ 10+ Years of Excellence
              </span>
            </div>

            <h1 className="hero-title" data-aos="fade-up" data-aos-delay="100">
              Full-Stack Developer
              <br />& Software Architect
            </h1>

            <p
              className="hero-subtitle mt-4"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <span id="typed" style={{ color: "#00d4ff" }}></span>
            </p>

            <p
              className="hero-description mt-4 mx-auto"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Delivering cutting-edge solutions that transform businesses.
              Specializing in scalable architectures, clean code, and innovative
              technology implementation.
            </p>

            <div
              className="d-flex justify-content-center gap-3 mt-5 flex-wrap"
              data-aos="zoom-in"
              data-aos-delay="250"
            >
              <Link to="/Portfolio/index" className="btn btn-glow">
                <span>View My Work</span>
              </Link>
              <Link to="/Contact/index" className="btn btn-outline-glow">
                <span>Start a Project</span>
              </Link>
              <a
                href="/Resume/SHAIKH_MUHAMMAD_ZEESHAN_RASHID.pdf"
                className="btn btn-outline-glow btn-scroll"
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Download CV</span>
              </a>
            </div>

            <div className="hero-stats mt-5">
              <div className="row g-4 justify-content-center">
                <div
                  className="col-6 col-md-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="stat-card">
                    <div className="stat-number">500+</div>
                    <div className="stat-label">Projects Delivered</div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-3"
                  data-aos="fade-up"
                  data-aos-delay="350"
                >
                  <div className="stat-card">
                    <div className="stat-number">300+</div>
                    <div className="stat-label">Happy Clients</div>
                  </div>
                </div>
                <div
                  className="col-6 col-md-3"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="stat-card">
                    <div className="stat-number">10+</div>
                    <div className="stat-label">Years Experience</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Tech Stack Section */}
      <section className="section tech-stack-section">
        <div className="container">
          <h2 className="section-title text-center" data-aos="fade-up">
            💻 Technology Stack
          </h2>
          <p
            className="section-subtitle text-center"
            data-aos="fade-up"
            data-aos-delay="50"
          >
            We work with industry-leading technologies to build robust solutions
          </p>

          <div className="row g-4 mt-4">
            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="tech-category">
                <h5 className="tech-title">🔧 Backend</h5>
                <div className="tech-tags">
                  <span className="tech-tag">ASP.NET Core</span>
                  <span className="tech-tag">Node.js</span>
                  <span className="tech-tag">Php</span>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="150"
            >
              <div className="tech-category">
                <h5 className="tech-title">🎨 Frontend</h5>
                <div className="tech-tags">
                  <span className="tech-tag">React</span>
                  <span className="tech-tag">Vue.js</span>
                  <span className="tech-tag">TypeScript</span>
                  <span className="tech-tag">Bootstrap</span>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="tech-category">
                <h5 className="tech-title">☁️ Cloud & DevOps</h5>
                <div className="tech-tags">
                  <span className="tech-tag">AWS</span>
                  <span className="tech-tag">Azure</span>
                  <span className="tech-tag">Docker</span>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="250"
            >
              <div className="tech-category">
                <h5 className="tech-title">🗄️ Databases</h5>
                <div className="tech-tags">
                  <span className="tech-tag">SQL Server</span>
                  <span className="tech-tag">PostgreSQL</span>
                  <span className="tech-tag">MongoDB</span>
                  <span className="tech-tag">InfluxDB</span>
                  <span className="tech-tag">MySQL</span>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="tech-category">
                <h5 className="tech-title">📱 Mobile</h5>
                <div className="tech-tags">
                  <span className="tech-tag">React Native</span>
                  <span className="tech-tag">Flutter</span>
                  <span className="tech-tag">Swift</span>
                  <span className="tech-tag">Kotlin</span>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-4"
              data-aos="zoom-in"
              data-aos-delay="350"
            >
              <div className="tech-category">
                <h5 className="tech-title">🤖 AI & ML</h5>
                <div className="tech-tags">
                  <span className="tech-tag">TensorFlow</span>
                  <span className="tech-tag">PyTorch</span>
                  <span className="tech-tag">OpenAI</span>
                  <span className="tech-tag">LangChain</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="section why-us-section">
        <div className="container">
          <h2 className="section-title text-center" data-aos="fade-up">
            ✨ Why Choose MZR Software
          </h2>

          <div className="row g-4 mt-4">
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="why-us-card">
                <div className="why-us-icon">🎯</div>
                <h5>Mission-Driven</h5>
                <p>
                  We're committed to understanding your business goals and
                  delivering solutions that drive real value.
                </p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <div className="why-us-card">
                <div className="why-us-icon">⚡</div>
                <h5>Fast Execution</h5>
                <p>
                  Agile methodology ensures rapid development cycles without
                  compromising on quality and testing.
                </p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="why-us-card">
                <div className="why-us-icon">🔒</div>
                <h5>Security First</h5>
                <p>
                  Enterprise-grade security protocols, data encryption, and
                  compliance with international standards.
                </p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay="250"
            >
              <div className="why-us-card">
                <div className="why-us-icon">🤝</div>
                <h5>12/5 Support</h5>
                <p>
                  Dedicated support team available around the clock to ensure
                  your systems run smoothly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Achievements Section */}
      <section className="section achievements-section">
        <div className="container">
          <h2 className="section-title text-center" data-aos="fade-up">
            🏆 Achievements & Certifications
          </h2>

          <div className="row g-4 mt-4">
            <div
              className="col-md-6 col-lg-3"
              data-aos="zoom-in"
              data-aos-delay="100"
            >
              <div className="achievement-card">
                <div className="achievement-icon">🏢</div>
                <h5>NTN Registered</h5>
                <p>
                  Officially registered with Pakistani tax authorities since
                  2018
                </p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div className="achievement-card">
                <div className="achievement-icon">✅</div>
                <h5>AgileScrum Certified</h5>
                <p>Team certified in Agile and Scrum methodologies</p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="zoom-in"
              data-aos-delay="250"
            >
              <div className="achievement-card">
                <div className="achievement-icon">📊</div>
                <h5>Industry Awards</h5>
                <p>
                  Recognized for excellence in software development and
                  innovation
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="section skills-section">
        <div className="container">
          <h2 className="section-title text-center" data-aos="fade-up">
            Core Expertise
          </h2>

          <div className="row g-4 mt-4">
            <div
              className="col-md-6 col-lg-3"
              data-aos="flip-left"
              data-aos-delay="100"
            >
              <div className="skill-card">
                <div className="skill-icon">💻</div>
                <h4>Backend Development</h4>
                <p>ASP.NET, C#, Node.js, Python, Java</p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="flip-left"
              data-aos-delay="150"
            >
              <div className="skill-card">
                <div className="skill-icon">⚛️</div>
                <h4>Frontend Development</h4>
                <p>React, Vue.js, Angular, TypeScript</p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="flip-left"
              data-aos-delay="200"
            >
              <div className="skill-card">
                <div className="skill-icon">☁️</div>
                <h4>Cloud & DevOps</h4>
                <p>AWS, Azure, Docker, Kubernetes</p>
              </div>
            </div>

            <div
              className="col-md-6 col-lg-3"
              data-aos="flip-left"
              data-aos-delay="250"
            >
              <div className="skill-card">
                <div className="skill-icon">🗄️</div>
                <h4>Database Design</h4>
                <p>SQL Server, PostgreSQL, MongoDB</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
